var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 60 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 60c-.5 0-.9-.2-1.3-.5-.7-.7-.7-1.9 0-2.6L56.9.5c.7-.7 1.9-.7 2.6 0s.7 1.9 0 2.6L3.1 59.5c-.3.3-.8.5-1.3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2 60c-.5 0-.9-.2-1.3-.5L.5 3.1C-.2 2.4-.2 1.2.5.5s1.9-.7 2.6 0l56.3 56.3c.7.7.7 1.9 0 2.6-.3.4-.8.6-1.2.6z"
  })));
};
export default SvgX;